module.exports = __webpack_public_path__ + "img/hs-03.fb9afbe9.svg";